export default function Logo({ markClass = "h-10 w-10", showText = true }) {
    return (
        <span className="flex items-center gap-3 select-none">
            <svg
                viewBox="0 0 44 44"
                className={markClass}
                aria-label="CG Service SRL"
                role="img"
            >
                <rect width="44" height="44" rx="4" fill="#E5795C" />
                <path d="M44 0H26L44 18V0Z" fill="#31261C" />
                <text
                    x="21"
                    y="32"
                    fontFamily="Outfit, Arial, sans-serif"
                    fontSize="19"
                    fontWeight="800"
                    letterSpacing="-1.5"
                    textAnchor="middle"
                    fill="#31261C"
                >
                    CG
                </text>
            </svg>
            {showText && (
                <span className="leading-none">
                    <span className="block font-display font-extrabold tracking-tight text-foreground text-[17px]">
                        CG SERVICE
                    </span>
                    <span className="block font-mono text-[8.5px] tracking-[0.18em] text-muted-foreground mt-1 whitespace-nowrap">
                        ELETTRODOMESTICI · RICAMBI · CONSULENZA
                    </span>
                </span>
            )}
        </span>
    );
}